<template>
  <a
    class="emd-link"
    @click="copyToClipBoard(qrCode)"
    data-testid="anchor"
  >
    <i class="uil uil-copy"></i>
      {{ $t('pix.clipboardCopy') }}
  </a>
</template>

<script>
export default {
  name: 'PixClipboardCopy',
  methods: {
    async copyToClipBoard (textToCopy) {
      await navigator.clipboard.writeText(textToCopy)
    }
  },
  computed: {
    qrCode () {
      return this.$store.getters.pix.qr_code
    }
  }
}
</script>
